"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _default = (0, _defineProperty2.default)({}, MerchandiseIds.PRODUCT_SERVICE_FREE, {
  ownedByHub: false,
  selfServicePurchasable: false,
  eligibility: {
    isEligible: true,
    notEligibleReason: null
  },
  pricingWrap: {
    pricingType: 'FLAT',
    prices: [{
      value: 0,
      currencyCode: 'USD'
    }]
  }
});

exports.default = _default;
module.exports = exports.default;